import { debounce } from 'lodash';
import { InputText } from 'primereact/inputtext';
import React, { useMemo } from 'react';
import styled from 'styled-components';

type InputFilterProps = {
  field: string;
  onChange: (value: string, field: string) => void;
  placeholder?: string;
  value?: string;
};

const StyledInputText = styled(InputText)`
  min-width: 60px;
`;

export const DataTableInputFilter: React.FC<InputFilterProps> = ({
  onChange,
  field,
  placeholder,
  value,
  ...rest
}) => {
  const debounedOnChange = useMemo(
    () =>
      debounce((inputValue: string, fieldName: string) => {
        onChange(inputValue, fieldName);
      }, 500),
    [onChange, field],
  );

  return (
    <StyledInputText
      defaultValue={value}
      placeholder={placeholder}
      onChange={(event) => debounedOnChange(event.target.value, field)}
      {...rest}
      autoComplete="off"
    />
  );
};
